import { useMemo, useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

//* HOC's
import { withUIContext, withDataContext } from 'context';

//* Components
import Text from 'components/common/Text';
import Button from 'components/common/Button';
import RelatedBlogItem from './RelatedBlogItem';
import Container from 'components/common/Container';

//* Style
import RelatedBlogPostsStyle from './style';

const RelatedBlogPosts = ({ articles, hasMore, blogListing, winWidth, relatedTitle, className, loadMoreArticles, pageParams }) => {
	//! Router
	const router = useRouter();

	//! States
	const [page, setPage] = useState(1);
	const [perPage, setPerPage] = useState(4);

	//! Load More
	const loadMore = useCallback(() => {
		loadMoreArticles({
			pageParams,
			queryParams: {
				...router.query,
				offset: articles.length,
			},
		});
	}, [articles, router]);

	//! Posts
	const posts = useMemo(() => {
		const items = blogListing ? articles : articles.slice(0, page * perPage);

		return (
			<Container
				row
				full
				className='rpb-items-container'>
				{items?.map((i, k) => {
					return (
						<RelatedBlogItem
							key={k}
							index={k}
							className={'col-3 col-t-4 col-ts-6 col-m-12'}
							{...i}
						/>
					);
				})}
			</Container>
		);
	}, [articles, blogListing, page, perPage]);

	//! Window Resize
	useEffect(() => {
		if (!blogListing) {
			setPerPage(winWidth >= 1024 && winWidth < 1280 ? 3 : 4);
			setPage(1);
		}
	}, [winWidth, blogListing]);

	return (
		<RelatedBlogPostsStyle className={className || ''}>
			<Container
				section
				className='rpb-container'>
				{!blogListing ? (
					<Text
						tag='h2'
						text={relatedTitle || 'relatedBlogPosts'}
						className='rpb-container-title font-ping-bolder h3'
					/>
				) : (
					''
				)}

				{posts}

				{((!blogListing && page * perPage < articles.length) || (blogListing && hasMore)) && (
					<Button
						className={'rpb-load-more-button'}
						text='loadMore'
						background={'transparent'}
						color={'ColorBigStone'}
						borderColor={'ColorBigStone'}
						hoverBackground={'ColorBigStone'}
						hoverColor={'ColorWhite'}
						onClick={() => (blogListing ? loadMore() : setPage(page + 1))}
					/>
				)}
			</Container>
		</RelatedBlogPostsStyle>
	);
};

export default withUIContext(withDataContext(RelatedBlogPosts, ['loadMoreArticles']), ['winWidth']);
